import React, {useEffect, useState} from 'react';
import {Link as RouterLink, useHistory, useParams} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Button, CircularProgress, Container, Grid, Snackbar, Box} from '@mui/material'
import {DataGrid} from '@mui/x-data-grid';
import Select from 'react-select';
import {GrantAccountStatementService, PeriodService} from '../shared/service';
import { Alert } from '@mui/material';
import AddGrantModal from "./add-grant-modal";
import EmailPreview from "./email-preview";
import {GasListColumnModel} from "./table-models";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import SelectMUI from '@mui/material/Select';
import {ISACTIVE} from '../../../constants';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const GrantAccountStatements = (props) => {
        const [list, setList] = useState([]);
        const [grantOpen, setGrantOpen] = useState(false);
        const [options, setOptions] = useState([]);
        const [countries, setCountries] = useState([]);
        const [periods, setPeriods] = useState([]);
        const [message, setMessage] = useState([]);
        const [messageType, setMessageType] = useState([]);
        const [selectedPeriod, setSelectedPeriod] = useState(-1);
        const [selectedPeriodObject, setSelectedPeriodObject] = useState({});
        const [ready, setReady] = useState(false);
        const [selectedGas, setSelectedGas] = useState(false);
        const [showPreview, setShowPreview] = useState(false);
        const [snackBarOpen, setSnackBarOpen] = useState(false);
        const initialValue = {countries: '', statuses: '', grantValidated: '', gasValidated: '', gasFound: ''};
        const [isLoading, setIsLoading] = useState(true);
        const filterParams = [];
        const [tempRow, setTempRow] = useState([]);
        const {id = ''} = useParams();
        const history = useHistory();
        const savedFilters = JSON.parse(localStorage.getItem("GtSt"));
        const [searchParam, setSearchParam] = useState(JSON.parse(localStorage.getItem("GtsSearch"))? JSON.parse(localStorage.getItem("GtsSearch")) : '');  
        const [selected, setSelected] = useState(savedFilters ? savedFilters : initialValue);
        const [rowList,  setRowList] = useState([]);

        // const listPreProcess = (list) => {
        //     return list.map(g => {
        //         return {
        //             ...g,
        //             countryName: (g.grantDetail.gasCountry) ? g.grantDetail.gasCountry.name : 'Unknown',
        //             grantName: g.grantDetail.grantName,
        //             grantValidated: g.grantDetail.emailsValidated,
        //             statusName: (g.status) ? g.status.name : ''
        //         }
        //     })
        // }

        useEffect(() => {           
            if (selectedPeriod !== -1 && periods.length > 0) {
                let spo = periods.find(o => o.id === selectedPeriod);
                if (spo !== undefined) {
                    setSelectedPeriodObject(spo)
                    GrantAccountStatementService
                        .getByPeriodId(selectedPeriod)
                        .then((response) => {
                            setList(response.data.results);                           
                            setTempRow(response.data.results);
                            setReady(true);
                            if(savedFilters){
                                setIsLoading(true);                
                                setSelected(JSON.parse(localStorage.getItem("GtSt")));
                                  } 
                                          
                              setIsLoading(false);
                        });
                }
            } else {
                setReady(true);
            }

        }, [selectedPeriod, periods]);

        useEffect(() => {
            filterList();
            localStorage.setItem('GtSt', JSON.stringify(selected));
            localStorage.setItem('code', 'GtSt');   
           },[selected]);

       useEffect(() => {
        localStorage.setItem('GtsSearch', JSON.stringify(searchParam));
        if(searchParam !== ''){
          searchKey(searchParam)
        }
      },[rowList, searchParam]);  
           
           const detectChange = (e) => {
            setSearchParam(e.target.value);
           // searchKey(e.target.value);
             }

             const searchKey = (e) => {
                let tempList = [];
                const filterBUffer = [] ; 
                rowList.forEach((filteredList) => {   
            if(filteredList.grantName?.toLowerCase().includes(e.toLowerCase())){
            filterBUffer.push(filteredList)
            }else if(filteredList.countryName?.toLowerCase().includes(e.toLowerCase())){
             filterBUffer.push(filteredList)
            }else if(filteredList.statusName?.toLowerCase().includes(e.toLowerCase())){
             filterBUffer.push(filteredList)
            }        
            tempList = filterBUffer
          })    
          setList(tempList);
              }

        useEffect(() => {
            GrantAccountStatementService.getById('options')
            .then((response) => {
                setOptions(response.data);
                setCountries(response.data.countries)
            })
            if (periods.length === 0) {
                PeriodService.getAll()
                    .then((response) => {
                        setPeriods(response.data);
                        const currentPeriod = response.data.filter(d => d.current);
                        if (currentPeriod.length > 0 && id === '') {
                            setSelectedPeriod(currentPeriod[0].id);
                            onPeriodChanged(currentPeriod[0].id);
                        } else {
                            setSelectedPeriod(parseInt(id, 10));
                        }
                    });
            } else if(id !== ''){
                setSelectedPeriod(parseInt(id, 10));
            }
            // eslint-disable-next-line
        }, [id, periods]);

        

        const tryToFindFiles = () => {
            setIsLoading(true);
            setList([])
            GrantAccountStatementService.relinkGasFiles(selectedPeriod)
                .then((response) => {
                    if (response.data.results && !response.data.error) {
                        setList(response.data.results);
                        setIsLoading(false);
                        setSnackBarMessage("Files that were matching were linked successfully.", 'success');
                    }
                }).catch((response) => {
                setSnackBarMessage("There was an error relinking files.", 'error');
            });
        }

        const handleClose = () => {
            setGrantOpen(false);
        }

        const setSnackBarMessage = (msg, msgType) => {
            setMessage(msg);
            setMessageType(msgType)
            setSnackBarOpen(true);
        }

        const onPreviewClicked = (row) => {
            setSelectedGas(row);
            setShowPreview(true);
        }

        
        const clearFilter = () => {
            setSelected(initialValue);
            localStorage.removeItem('GtSt');
           }

        const onPeriodChanged = (period) => {
            setSelectedPeriod(period);
            history.push('/gas/account-statements/' + period,
                {periods: periods});
        }
        
       const handleChange = (param, e) => {
        console.log(param, e)
        setSelected({
            ...selected, 
            [param]: e.target.value})
      }

      const filterList = () => {   
        selected.countries !== '' && filterParams.push({'countryName' : selected.countries})
         selected.statuses !== '' && filterParams.push({'statusName' : selected.statuses})
         selected.grantValidated !== '' && filterParams.push({'grantValidated' : selected.grantValidated})
         selected.gasValidated !== '' && filterParams.push({'emailsValidated' : selected.gasValidated})
         selected.gasFound !== '' && filterParams.push({'gasFound' : selected.gasFound})
         let tempList = tempRow;
        filterParams.forEach(parent => {
            const filterBUffer = [] ;    
           tempList.forEach(el => {             
             Object.entries(el).map(key => {
                let parentKey = Object.keys(parent)
                let parentValue = Object.values(parent)
                if(key[0] === parentKey.toString()){
                    if(key[1] === parentValue[0]){
                        filterBUffer.push(el);
                    }
                }
             })               
             })
             tempList = filterBUffer;              
        });
                setList(tempList) 
                setRowList(tempList);                    
    }
    
    // const handleNavigation = (param) => {   
    //     localStorage.setItem('filterParam', JSON.stringify(param))     
    //     localStorage.setItem('code', 'GtSt');
        
    //      }
    const onSelectChange = (event, values) => {
        setSelected({...selected, countries: values})
        console.log(values);
      }

      const handleSubmit = (event) => {
          event.preventDefault();
          filterList();
        };

        return (
            <Container>
                <header>
                    <h1>Account Statement Distribution Manager</h1>
                </header>
                {ready ?
                    <div>
                        <Grid container spacing={5}>
                            <Grid item xs={6}>
                                Select Period:
                                <Select
                                    value={{value: selectedPeriod, label: selectedPeriodObject.name}}
                                    onChange={value => onPeriodChanged(value.value)}
                                    options={periods.map(p => ({value: p.id, label: p.name}))}/>

                            </Grid>
                            <Grid item xs={6}>
                                <div>&nbsp;</div>
                                {
                                    selectedPeriod && selectedPeriodObject.periodDocumentFolder &&
                                    <Button
                                        onClick={() => tryToFindFiles()}
                                        color="primary" variant="contained">
                                        Relink GAS Files</Button>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    selectedPeriodObject.id && selectedPeriodObject.periodDocumentFolder && <>Google folder
                                        path: {selectedPeriodObject.periodDocumentFolder}</>
                                }
                                {
                                    selectedPeriodObject.id && !selectedPeriodObject.periodDocumentFolder &&
                                    <Alert severity="error">This period does
                                        not have associated google folder.
                                        Please <Link component={RouterLink}
                                                     to={'/gas/reporting-period/' + selectedPeriodObject.id}>provide google
                                            folder path</Link>
                                        &nbsp; for where to find statement attachment files.</Alert>
                                }
                            </Grid>
                            {
                                selectedPeriod &&
                                <Grid item xs={12}>
                                    <Button variant="contained" color="primary" component={RouterLink} onClick={() => setGrantOpen(true)}>Add Grants</Button>
                                </Grid>
                            }
                            <Grid item xs={12}>
                                {
                                    selectedPeriod &&
                                    <Grid item xs={12}>
                        <form onSubmit={handleSubmit}>
                        <Grid container spacing={4}>
                        <Grid item xs={12}>
                        <FormControl sx={{ m: 1, minWidth: 200 }}>
                        <Autocomplete
                           value={selected.countries}
                           onChange={(event, newValue) => {
                             setSelected({ ...selected, countries: newValue == null ? "" : newValue});
                           }}  
                           options={countries?.map((option) => option.name)}
                           style={{ width: 300 }}
                           renderInput={(params) => (
                             <TextField {...params} label="Country" variant="outlined" />
                           )}
                         />                      
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Status</InputLabel>
                           <SelectMUI value={selected.statuses} onChange={(e) => handleChange('statuses', e)}
                          endAdornment={
                            selected.statuses !== '' ? (
                                <IconButton sx={{visibility: selected.statuses !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 statuses: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {options.statuses?.map((el) => (
                      <MenuItem    value={el.name}>
                      {el.name}
                    </MenuItem>
                               ))}      
                            
                           </SelectMUI>
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Grant Validated</InputLabel>
                           <SelectMUI value={selected.grantValidated} onChange={(e) => handleChange('grantValidated', e)}
                          endAdornment={
                            selected.grantValidated !== '' ? (
                                <IconButton sx={{visibility: selected.grantValidated !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 grantValidated: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {ISACTIVE?.map((el) => (
                      <MenuItem    value={el.value}>
                      {el.key}
                    </MenuItem>
                               ))}      
                            
                           </SelectMUI>
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>GAS Validated</InputLabel>
                           <SelectMUI value={selected.gasValidated} onChange={(e) => handleChange('gasValidated', e)}
                          endAdornment={
                            selected.gasValidated !== '' ? (
                                <IconButton sx={{visibility: selected.gasValidated !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 gasValidated: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {ISACTIVE?.map((el) => (
                      <MenuItem    value={el.value}>
                      {el.key}
                    </MenuItem>
                               ))}      
                            
                           </SelectMUI>
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>GAS Found</InputLabel>
                           <SelectMUI value={selected.gasFound} onChange={(e) => handleChange('gasFound', e)}
                          endAdornment={
                            selected.gasFound !== '' ? (
                                <IconButton sx={{visibility: selected.gasFound !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 gasFound: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {ISACTIVE?.map((el) => (
                      <MenuItem    value={el.value}>
                      {el.key}
                    </MenuItem>
                               ))}      
                            
                           </SelectMUI>
                         </FormControl>
                         <Button style={{marginTop: "10px"}} variant="contained" color="primary" onClick={clearFilter}>Clear Filter</Button>
                         </Grid>
                        
                         
                                </Grid>
                                     </form>
                                     <Grid item xs={12}>
                        <Box
                            component="form"
                            sx={{'& > :not(style)': { m: 1, width: '25ch' }}}
                           // style={{float: "right"}}
                            noValidate
                            autoComplete="on"
                          >   
                          <TextField type="text" defaultValue={searchParam} label="Search" variant="standard" onChange={detectChange}  />
                         </Box>
                                
                                    <DataGrid
                                        loading={isLoading}
                                        rowHeight={35}
                                        autoHeight={true}
                                        rows={list}
                                        columns={GasListColumnModel(onPreviewClicked)}
                                        pageSize={20}/>
                                        </Grid>  
                                           </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Snackbar open={snackBarOpen} autoHideDuration={6000} onClose={() => setSnackBarOpen(false)}>
                            <Alert onClose={() => setSnackBarOpen(false)} severity={messageType}>
                                {message}
                            </Alert>
                        </Snackbar>
                    </div>

                    :
                    <CircularProgress data-test-id="loading-component"/>
                }
                <EmailPreview data={selectedGas} open={showPreview} handleClose={() => {
                    setShowPreview(false);
                }}/>
                <AddGrantModal handleClose={handleClose} grantOpen={grantOpen}
                               period={selectedPeriod} setSnackBarMessage={setSnackBarMessage} setGrantList={setList}/>
            </Container>
        );
    }
;

export default GrantAccountStatements;
